export const ru = {
    'agency-login': 'Агентство',
    'build-date': 'Дата составления отчёта',
    download: 'Скачать отчёт',
    'end-date': 'Дата окончания',
    id: 'ID',
    link: 'Скачать отчёт',
    'report-kind': 'Тип отчёта',
    'start-date': 'Дата начала',
    status: 'Статус'
};
